var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.556,
    height: 15.556
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M8.839 14.495a1.5 1.5 0 01-2.121 0 1.5 1.5 0 010-2.12l4.596-4.597-4.596-4.596a1.5 1.5 0 010-2.122 1.5 1.5 0 012.12 0l5.658 5.657a1.5 1.5 0 010 2.122z"
  })));
}
export default SvgRightArrow;